import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";
import moment from "moment";

import { useTransactions } from "../../context/TransactionsContext";

import {
  FilterBtn,
  FilterModal,
  Summary,
  ThreeYearsModal,
  LegacyUserModal,
  Transactions,
  Message,
} from "../../components";

import { getTransactions } from "../../services/api";

import { isGolPremiumEnabled } from "../../utils/statementFare";

const MyTransactions: FC = () => {
  const { t } = useTranslation("filter");
  const { state, dispatch } = useTransactions();
  const flags = useFlags();
  const { apiDomain } = flags;
  const golPremiumEnabled = isGolPremiumEnabled(flags);
  const [isLoading, setIsLoading] = useState(true);

  const openModal = (action: boolean) => {
    dispatch({
      type: "MODAL",
      modals: { legacyUserModalOpen: action, filterModalOpen: false, threeYearsModalOpen: false },
    });
  };

  const sevenDaysTransactions = async () => {
    const startDate = moment().subtract("7", "d");
    const endDate = moment();

    const transactions = await getTransactions({
      apiDomain,
      jwt: state.tokens.jwt,
      startDate,
      endDate,
      mileTypes: "ALL",
      transactionType: "ALL",
      golPremiumEnabled,
    });

    if (transactions) {
      setIsLoading(false);
      dispatch({
        type: "FILTER",
        filter: {
          periodFilter: "LAST_7_DAYS",
          pointsFilter: undefined,
          transactionFilter: undefined,
          startDate: startDate.format("DD/MM/YYYY"),
          endDate: endDate.format("DD/MM/YYYY"),
        },
        transactions,
      });

      if (transactions[0]?.isLegacy) {
        dispatch({
          type: "MODAL",
          modals: { filterModalOpen: false, threeYearsModalOpen: false, legacyUserModalOpen: true },
        });
      }
    }
  };

  useEffect(() => {
    sevenDaysTransactions();
  }, [golPremiumEnabled]);

  useEffect(() => {
    if (state.transactions[0]?.isLegacy) {
      openModal(true);
    }
  }, []);

  const renderTransactions = () => {
    if (!isLoading) {
      if (state.error || state.transactions === undefined) {
        return <Message type="error" />;
      }
      if (state.transactions.length === 0) {
        return <Message type="empty" />;
      }
      return (
        <>
          <Summary />
          <Transactions />
        </>
      );
    }
    return null;
  };

  // eslint-disable-next-line no-unused-vars
  const titles: { [key in Exclude<PeriodFilters, "LAST_3_YEARS_MORE">]: string } = {
    LAST_7_DAYS: t("last7Days"),
    LAST_30_DAYS: t("last30Days"),
    THIS_YEAR: t("thisYear"),
    LAST_YEAR: t("lastYear"),
  };

  return (
    <section className="my-transactions">
      <div className="my-transactions__top">
        <h4>{titles[state.filter.periodFilter as Exclude<PeriodFilters, "LAST_3_YEARS_MORE">]}</h4>
        <div className="my-transactions__btns">
          <FilterBtn />
        </div>
      </div>
      {renderTransactions()}
      {state.modals?.filterModalOpen && <FilterModal />}
      {state.modals?.threeYearsModalOpen && <ThreeYearsModal />}
      {state.modals?.legacyUserModalOpen && <LegacyUserModal />}
    </section>
  );
};

export default MyTransactions;
